const global = window

// Remplissage automatique
inputs.behavior.confirm = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.confirm) {
        // si data.confirm est un texte, le convertir en tableau
        if (typeof data.confirm === 'string') {
            data.confirm = {
                title: data.confirm,
                icon: 'warning',
                text: null,
                html: null,
            }
        }

        input.data('hold', true)
        input.click(function (e) {
            if (!input.data('hold')) {
                setTimeout(function () {
                    input.data('hold', true)
                }, 100)
            } else {
                swal(
                    {
                        title: data.confirm.title,
                        type: data.confirm.icon,
                        text: data.confirm.text,
                        html: data.confirm.html,
                        showCancelButton: true,
                        confirmButtonColor: '#d1202f',
                        cancelButtonColor: '#686868',
                        confirmButtonText: 'Oui',
                        cancelButtonText: 'Non',
                        closeOnConfirm: true,
                    },
                    function (confirmed) {
                        if (confirmed) {
                            input.removeData('hold');
                            input.get(0).click();
                        }
                    },
                )

                e.preventDefault();
                e.stopPropagation();
            }
        })
    }
    return data
}
